import React from "react"
import classnames from "classnames"
import * as cl from "./Plan.module.css"
import BrowserLink from "../../BrowserLink";
import arrowPremium from "../../../icons/arrow-premium.svg";
import strikeThrough from "../../../icons/strike-through.svg";
import { getMediaUrl } from "../../../utils/utils";

const Plan = ({
  isYearly,
  className,
  analyticsData,
  activePremium,
  data: {
    highlight,
    name,
    description,
    options,
    priceMonth,
    priceYear,
    payInfo,
    startButtonText,
    startButtonLink
  }
}) => {

  let startLink = typeof startButtonLink === 'string' ? startButtonLink : isYearly ? startButtonLink.yearly : startButtonLink.monthly;
  const isPremium = name === 'Premium';
  const isFree = name === 'Free';
  const shouldHideArrow = activePremium && !isYearly;
  const isHighlighted = highlight && !(activePremium && !isYearly);

  return (
    <>
    <section className={classnames(cl.plan, { [cl.plan_highlight]: isHighlighted }, className)}>
      {isYearly && <img src={getMediaUrl(arrowPremium)} alt="arrow-premium" className={classnames(cl.arrow, { [cl.arrow_shifted] : activePremium })} />}

      <header className={cl.head}>
        <h3 className={cl.title}>{isYearly ? 'Annual' : 'Monthly'}</h3>
      </header>

      <p className={cl.description}>{description}</p>

      <div className={cl.oldPriceContainer}> 
        {!isFree && <p className={classnames(cl.oldPrice, { [cl.hidden]: !isYearly })}>{isYearly && `Normally ${priceMonth}/mo`}
          <img src={getMediaUrl(strikeThrough)} alt="arrow-premium" className={cl.strikeThrough} />
        </p>}
      </div>
      <p className={cl.price}>
        {priceMonth || priceYear ? (
          <>
            {isYearly ? priceYear : priceMonth}
            <small>/mo</small>
          </>
        ) : 'Free'}
      </p>
      

      <p className={cl.payInfo}>
        <span dangerouslySetInnerHTML={{ __html: typeof payInfo === 'string' ? payInfo : isYearly ? payInfo.yearly : payInfo.monthly }} />
      </p>

      <BrowserLink
        href={startLink}
        target="_blank"
        rel="noreferrer"
        className={cl.startBtn}
        onClick={() => {
          // actid=7.2
          window.analytics?.track("button:click", {
            "button_name": typeof startButtonText === 'string' ? startButtonText : isYearly ? startButtonText.yearly : startButtonText.monthly,
            "parent_object_title": analyticsData.redirectionObjectTitle,
            "title": analyticsData.title,
            "url": startLink
          });
        }}
      >
        {typeof startButtonText === 'string' ? startButtonText : isYearly ? startButtonText.yearly : startButtonText.monthly}
      </BrowserLink>

      <div className={cl.lists}>
        {options.map((section) => (
          <React.Fragment key={section.title}>
            <h4 className={cl.subTitle}>{section.title}</h4>

            {section.list.map((list, listI) => (
              <ul className={cl.list} key={listI}>
                {list.map((item, itemI) => (
                  <li className={classnames(cl.listItem, { [cl.listItemDisabled]: !item.checked })} key={itemI}>{item.title}</li>
                ))}
              </ul>
            ))}
          </React.Fragment>
        ))}
      </div>

     

   
      <BrowserLink
        href={startLink}
        target="_blank"
        rel="noreferrer"
        className={cl.startBtn}
        onClick={() => {
          // actid=7.2
          window.analytics?.track("button:click", {
            "button_name": typeof startButtonText === 'string' ? startButtonText : isYearly ? startButtonText.yearly : startButtonText.monthly,
            "parent_object_title": analyticsData.redirectionObjectTitle,
            "title": analyticsData.title,
            "url": startLink
          });
        }}
      >
        {typeof startButtonText === 'string' ? startButtonText : isYearly ? startButtonText.yearly : startButtonText.monthly}
      </BrowserLink>

    </section>
    </>
  )
}

export default Plan
